import { Typography } from "@material-ui/core";
import { get } from "lodash";
import moment from "moment";
import React from "react";

const CustomTimeField = ({ record = {}, source, isDateTime }: any) => {
  const time = get(record, source);

  return (
    <Typography variant="body2">
      {moment(time, "hh:mm").format("hh:mm A")}
    </Typography>
  );
};

export default CustomTimeField;
